import { useState, useMemo, useEffect } from 'react';
import { useIsMounted } from 'src/shared/hooks/useIsMounted';
import { useLocalStorage } from 'src/shared/hooks/useLocalStorage';
import { LocalStorageKeys } from 'src/shared/models/enums/localStorageKeys.enum';
import SearchField from 'src/shared/components/form/searchField';
import { PageFilterSection } from 'src/shared/components/organisms/pageFilterSection';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { DEFAULT_PAGE_INDEX, DEFAULT_PAGE_SIZE } from 'src/shared/models/enums/gridFilterConfig';
import { AutogiroSearchFilter } from '../models/autogiroSearchFilter';
import { AutogiroDataGrid } from '../components/autogiroDataGrid';

export const AutogiroMandateOverviewPage = () => {
  const isMounted = useIsMounted();
  const [tempSearchString, setTempSearchString] = useState<string | undefined>(undefined);
  const [searchInitialized, setSearchInitialized] = useState<boolean>(false);
  const [autogiroSearchFilter, setAutogiroSearchFilter] = useLocalStorage(LocalStorageKeys.AutogiroConsentSearchFilter, {
    sortCol: 'autogiroMandate_id',
    sortDir: 'desc',
    pageIndex: DEFAULT_PAGE_INDEX,
    pageSize: DEFAULT_PAGE_SIZE,
  } as AutogiroSearchFilter);

  const searchFilter: AutogiroSearchFilter = useMemo(() => {
    return {
      filter: autogiroSearchFilter?.filter,
      pageSize: autogiroSearchFilter?.pageSize,
      pageIndex: autogiroSearchFilter?.pageIndex,
      sortCol: autogiroSearchFilter?.sortCol,
      sortDir: autogiroSearchFilter?.sortDir,
    } as AutogiroSearchFilter;
  }, [
    autogiroSearchFilter?.filter,
    autogiroSearchFilter?.pageIndex,
    autogiroSearchFilter?.pageSize,
    autogiroSearchFilter?.sortCol,
    autogiroSearchFilter?.sortDir,
  ]);

  useEffect(() => {
    if (isMounted() && searchInitialized) {
      if (tempSearchString === '') {
        setAutogiroSearchFilter((prev) => ({ ...prev, ...{ filter: '', pageIndex: 0 } }));
      }
      if (tempSearchString && tempSearchString.length >= 2) {
        setAutogiroSearchFilter((prev) => ({ ...prev, ...{ filter: tempSearchString, pageIndex: 0 } }));
      } else {
        setAutogiroSearchFilter((prev) => ({ ...prev, ...{ filter: '', pageIndex: 0 } }));
      }
    }
  }, [isMounted, searchInitialized, setAutogiroSearchFilter, tempSearchString]);

  return (
    <>
      <PageFilterSection
        leftContent={
          <SearchField
            initialValue={searchFilter.filter || ''}
            onSearch={(newSearchString) => {
              setSearchInitialized(true);
              setTempSearchString(newSearchString);
            }}
          />
        }
      />
      <AutogiroDataGrid
        loadingCallback={(x) => ConsoleHelper.log(x)}
        searchFilter={searchFilter}
        searchFilterCallback={(newFilter) =>
          setAutogiroSearchFilter((prev) => ({
            ...prev,
            ...newFilter,
          }))
        }
      />
    </>
  );
};
